import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  ModalComponent as DpacModalComponent,
  InputFieldComponent,
  ButtonComponent,
} from '@mic-ac/ui-kit';
import { WizardFormSubmitService } from '../../../../core/services/wizard-form-submit/wizard-form-submit.service';

@Component({
  selector: 'app-nuova-collezione-modal',
  standalone: true,
  imports: [
    DpacModalComponent,
    InputFieldComponent,
    ButtonComponent,
    ReactiveFormsModule,
  ],
  template: `
    <dpac-modal
      title="Aggiungi la tua collezione"
      size="custom"
      (closed)="closed.emit($event)"
    >
      <form modal-body [formGroup]="form" class="flex  flex-col w-full">
        <dpac-input-field
          formControlName="titolo"
          label="Titolo"
          placeholder="Inserisci"
          [required]="true"
        />
      </form>
      <div modal-buttons class="flex gap-4 justify-end">
        <dpac-button
          classe="tiertiary custom-button-lg"
          label="Annulla"
          (onClick)="closed.emit(false)"
        />
        <dpac-button
          classe="primary custom-button-lg"
          label="Conferma"
          [disabled]="form.invalid || submitting()"
          (onClick)="onSubmit()"
        />
      </div>
    </dpac-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NuovaCollezioneModalComponent {
  readonly #fb = inject(FormBuilder);
  readonly #submitLogic = inject(WizardFormSubmitService);

  closed = output<any>();
  submitting = signal(false);

  form = this.#fb.group({
    titolo: ['', Validators.required],
  });

  get titoloValue(): string {
    return this.form.get('titolo')?.value ?? '';
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    this.submitting.set(true);
    this.#submitLogic.setupTitolo({ titolo: this.titoloValue }).subscribe({
      next: (res) => {
        this.closed.emit(res.element);
      },
      error: () => this.submitting.set(false),
    });
  }
}
